import { render, staticRenderFns } from "./LeftMenu_Ap.vue?vue&type=template&id=2df97b97&scoped=true"
import script from "./LeftMenu_Ap.vue?vue&type=script&lang=js"
export * from "./LeftMenu_Ap.vue?vue&type=script&lang=js"
import style0 from "./LeftMenu_Ap.vue?vue&type=style&index=0&id=2df97b97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df97b97",
  null
  
)

export default component.exports